import currencySimpleUtility from '@utils/currencySimple';

/**
 * Formats a promo code object for display in reconciliation reports.
 * Output format: "[code] - [value]"
 *   - PERCENT:  "OFF5 - 5%"
 *   - FIXED:    "COLD5 - $5.00 USD"
 *
 * Supports both field naming conventions from the API:
 *   FIXED  → promoCode.amount  (or promoCode.value as fallback)
 *   PERCENT → promoCode.percentage (or promoCode.value as fallback, expected 0–1 scale)
 *
 * @param {Object} promoCode - { code, discountType, amount|value, percentage|value }
 * @param {string} currency  - ISO currency code (e.g. "USD")
 * @returns {string}
 */
export default function formatPromoCodeReport(promoCode, currency) {
    if (!promoCode?.code) return '';
    const { code, discountType } = promoCode;
    const discountTypeUpper = discountType?.toUpperCase();

    if (discountTypeUpper === 'PERCENT') {
        const rate = promoCode.percentage ?? promoCode.value;
        if (rate == null) return code;
        return `${code} - ${rate * 100}%`;
    }
    if (discountTypeUpper === 'FIXED') {
        const amount = promoCode.amount ?? promoCode.value;
        if (amount == null) return code;
        const formatted = currencySimpleUtility(amount, currency);
        return `${code} - ${formatted} ${currency}`;
    }
    return code;
}
